import { styled, component } from '../../../utils/style';
import { StyleColor } from '../../../utils/styles-constants';


export const StyledAppInfo = styled()(component.div, 'StyledAppInfo') `
	height: 50px;
	font-size: 13px;
	border-bottom: 1px solid ${StyleColor.Grey100};
	display: flex;
	align-items: center;
`;

export const AppInfoTitle = styled()(component.span, 'AppInfoTitle') `
	flex-grow: 1;
	font-weight: bold;
	color: ${StyleColor.Black};
`;

export const AppInfoValue = styled()(component.span, 'AppInfoValue') `
	font-size: 13px;
	color: ${props => props.theme.primary.contentColor};
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/AppInfo/styles.ts